module.exports = __webpack_public_path__ + "img/curriculum.ea4c11e9.png";